import {
  Grid,
  IconButton,
  Button,
  Checkbox,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import Block from "../../components/Block";
import DataTable from "../../components/DataTable";
import { useState, useEffect } from "react";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ConfirmDialog from "../../components/ConfirmDialog";

import { useParams } from "react-router-dom";
import {
  getCustomerDayOfWeekRestrictions,
  updateCustomerDayOfWeekRestrictions,
} from "../../distflowAPI/customersApi";
import { Input } from "@mui/base";

export default function CustomerDayOfWeekRestrictions() {
  const { id } = useParams();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [settings, setSettings] = useState({
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sun: false,
  });
  function fetchRestrictions() {
    getCustomerDayOfWeekRestrictions(id).then((res) => {
      setSettings(res.data);
    });
  }
  useEffect(() => {
    fetchRestrictions();
  }, []);
  const days = {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sun: "Sunday",
  };
  return (
    <Block>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Day Of Week Restrictions</h3>
        <Button
          type="submit"
          variant="contained"
          sx={{ pt: 1, pb: 1, mb: 1 }}
          onClick={() => {
            updateCustomerDayOfWeekRestrictions(id, settings).then((res) => {
              console.log("res= ", res);
              fetchRestrictions();
            });
          }}
        >
          Save
        </Button>
      </div>
      <Stack>
        {Object.keys(days).map((key) => (
          <Stack direction={"row"} alignItems={"center"}>
            <Checkbox
              onChange={(e) => {
                setSettings({
                  ...settings,
                  [key]: e.target.checked,
                });
              }}
              checked={settings[key]}
            />
            <Typography>{days[key]}</Typography>
          </Stack>
        ))}
        <Typography>Notes</Typography>
        <TextField
          value={settings.note}
          onChange={(e) => setSettings({ ...settings, note: e.target.value })}
        />
      </Stack>
    </Block>
  );
}
